<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button size="medium" type="primary" @click="jumpToPage('sqlTemplateAddEdit')" v-if="isShowByPermission('/wyms/sqlTool/template/manage')">新建模板</el-button>
            <el-input size="medium" class="search-input search-input--right" placeholder="请输入模板名称"
                      v-model="sqlName" @keyup.enter.native="sqlToolTemplateListFunc">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="sqlToolTemplateListFunc"></el-button>
            </el-input>
        </div>
        <div>
            <el-table
                :height="windowHeight - 245"
                :data="dataList"
                style="width: 100%" border
            >

                <el-table-column
                    label="模板名称"
                    align="center" show-overflow-tooltip
                >
                    <template slot-scope="scope">
                         <span class="link" @click="jumpToPage('sqlTemplateDetail', {id: scope.row.id})">
                        {{ scope.row.tempName }}
                         </span>
                    </template>

                </el-table-column>
                <el-table-column
                    label="模板内容" show-overflow-tooltip
                    align="center"
                    width="450px"
                >
                    <template slot-scope="scope">
                        {{scope.row.tempContext}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="所属模块"
                    align="center" show-overflow-tooltip
                    prop="moduleName"
                >
                </el-table-column>
                <el-table-column
                    label="模板分类" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{['', '查询', '更新数据', '删除数据', '修改表结构', '删除表'][scope.row.tempType]}}
                    </template>
                </el-table-column>

                <el-table-column
                    label="创建日期" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.createdTime | dateFilter}}</span>
                    </template>
                </el-table-column>

                <el-table-column width="140"
                                 label="操作"
                                 align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small"
                                   @click="jumpToPage('sqlTemplateExec', {id: scope.row.id})">执行
                        </el-button>
                        <el-button type="text" size="small" @click="deleteHandler(scope.row.id)" v-if="isShowByPermission('/wyms/sqlTool/template/manage')">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
    </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";
    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        sqlToolTemplateList,
        sqlToolTemplateDelete
    } from '@/api/sql';

    export default {
        name: 'schoolList',
        data() {
            return {
                sqlName: '',
                dataList: [],
            }
        },
        computed: {
        },
        filters: {
            dateFilter(time) {
                return time ? time.slice(0, time.indexOf(' ')) : ''
            }
        },
        created() {
            // this.sqlToolTemplateListFunc();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.sqlToolTemplateListFunc();
            });
        },
        mixins: [windowResize, baseMixin],
        methods: {
            isShowByPermission,
            deleteHandler(sqlTemplateId) {
                this.$confirm('确认要删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    sqlToolTemplateDelete({
                        sqlTemplateId
                    })
                        .then(() => {
                            this.$message.success(`删除成功`);
                            this.sqlToolTemplateListFunc();
                        })
                });
            },
            sqlToolTemplateListFunc() {
                sqlToolTemplateList({
                    sqlName: this.sqlName,
                })
                    .then(data => {
                        this.dataList = data;
                    })
            }
        }
    }
</script>
<style>
    #moduleAppList .el-select {
        width: 120px;
    }
</style>
<style lang="scss" scoped>
    #moduleAppList {
        padding: 12px;

        .pagination-container {
            margin-top: 10px;
        }

        .top {
            padding-bottom: 10px;
            overflow: hidden;

        }

        a, .link {
            color: #409EFF;
            cursor: pointer;
        }

        .state-container {
            margin: 15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/sql/sqlTemplateList.vue